import { useSelector } from 'react-redux';
import { selectMachines, selectSelectedItem } from '@reducers/machines';
import { selectMachinesHeaderConfig } from '@reducers/details';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackMachineHistoryOpened = () => {
  const machines = useSelector(selectMachines) as Machine[];
  const selectedItem = useSelector(selectSelectedItem) as Machine;
  const headerConfig = useSelector(selectMachinesHeaderConfig) as { displayMode?: string } | null;

  useTrackScreenOpened(TRACKING_EVENTS.MACHINE_HISTORY, () => ({
    totalBatchCount: 0,
    displayMode: headerConfig?.displayMode || '',
    machineCount: machines?.length || 0,
    selectedMachineId: selectedItem?.machineId ? String(selectedItem.machineId) : undefined,
    selectedMachineName: selectedItem?.shortName || selectedItem?.fullName || undefined,
  }));
};
